import { t } from 'i18next'
import React, { FC, useCallback } from 'react'
import { useRecoilValue } from 'recoil'

import { isFromAppAtom } from '../../../state/common/atoms'
import { useOHC } from '../../hooks/useOHC'
import FullScreenModal from '../Modal/FullScreenModal/FullScreenModal'

const OHCRestrictedModal: FC = () => {
  const { setOHC } = useOHC()
  const isFromApp = useRecoilValue(isFromAppAtom)

  const onDcRedirect = useCallback(
    (queue: string) => {
      if (isFromApp) {
        window.location.replace(t('component.digitalClinicTile.redirectUrlOMApp'))
      } else {
        window.open(
          `${t(
            'component.digitalClinicTile.redirectUrlOMWeb'
          )}/?redirectAfterLogin=/digital-clinic/new/${queue}`
        )
      }
    },
    [isFromApp]
  )
  return (
    <FullScreenModal
      modalId="continuous_care_restriction"
      onClose={() => setOHC(false, true)}
      onContinue={() => setOHC(false, true)}
      onDigitalClinic={onDcRedirect}
    />
  )
}

export default OHCRestrictedModal
